export default __webpack_public_path__ + "static/media/giphy.df50c676.gif";